import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { H4 } from 'foundations-components/transitional/components/H4';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Fragment, useMemo } from 'react';
import { useSelector } from 'react-redux';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getServices } from '../../slices/serviceCatalogSlice';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';

/* @ts-expect-error module is untyped */
import { isQa } from '../../utils/env';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const relevantServiceIds = isQa() ? [1290, 1309, 1292] : [5, 24, 7];

// textKey: slug
const industriesButtons = {
  TECHNOLOGY_SOFTWARE: '/technology-software',
  BANKING_FINANCIAL_SERVICES: '/banking-financial-services',
  MARKETING_SERVICES: '/marketing-services'
};
const LinkButton = ({
  buttonText,
  to
}) => /*#__PURE__*/_jsx(UIRouterLink, {
  to: to,
  use: "unstyled",
  children: /*#__PURE__*/_jsx(SelectableButton, {
    marginBlockEnd: "700",
    children: buttonText
  })
});
export default function NoResultsState({
  searchTerm
}) {
  const noResultsTextKey = searchTerm ? 'noResultsSearchTerm' : 'noResults';
  const services = useSelector(getServices);
  const renderedServicesButtons = useMemo(() => {
    return relevantServiceIds.map(serviceId => {
      const serviceObject = services.filter(service => {
        return service.id === serviceId;
      })[0];
      return serviceObject && /*#__PURE__*/_jsx(LinkButton, {
        buttonText: serviceObject.name,
        to: serviceObject.apiName
      }, serviceObject.apiName);
    });
  }, [services]);
  const renderedIndustriesButtons = useMemo(() => {
    return Object.keys(industriesButtons).map(textKey => /*#__PURE__*/_jsx(LinkButton, {
      buttonText: unescapedText(`marketplace-ui-common.industry.${textKey}.sentence`),
      to: industriesButtons[textKey]
    }, textKey));
  }, []);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `ecosystem-marketplace-solutions-ui.storefront.results.noResultsEmptyState.${noResultsTextKey}`,
        options: {
          searchTerm
        }
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `ecosystem-marketplace-solutions-ui.storefront.results.noResultsEmptyState.message`
      })
    }), /*#__PURE__*/_jsxs(Grid, {
      "data-test-id": "search-results-empty-state",
      marginBlockStart: "800",
      marginInline: "0",
      children: [/*#__PURE__*/_jsxs(GridItem, {
        size: {
          sm: 12,
          md: 4
        },
        paddingInline: "0",
        children: [/*#__PURE__*/_jsx(H4, {
          marginBlockEnd: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'ecosystem-marketplace-solutions-ui.storefront.results.noResultsEmptyState.servicesLabel'
          })
        }), renderedServicesButtons]
      }), /*#__PURE__*/_jsxs(GridItem, {
        size: {
          sm: 12,
          md: 4
        },
        paddingInline: "0",
        children: [/*#__PURE__*/_jsx(H4, {
          marginBlockEnd: "700",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'ecosystem-marketplace-solutions-ui.storefront.results.noResultsEmptyState.industriesLabel'
          })
        }), renderedIndustriesButtons]
      })]
    })]
  });
}